import React, { useState } from "react";
import "../../styles/categories.scss";
import StaticImageList from "../static-image-list/static-image-list";

const GalleryComponent = () => {
  const [selectedCategory, setSelectedCategory] = useState("Piatti");
  const [selectedSubcategory, setSelectedSubcategory] = useState("Bar");

  const LOCALLE_SUBCATEGORIES = [
    "Bar",
    "Biblioteca",
    "Cantinetta",
    "Dispensa",
    "SallaDellaMusica",
    "Studio",
  ];

  const imageData = {
    Piatti: [
      "/gallery/Piatti/Piatti1.jpg",
      "/gallery/Piatti/Piatti2.jpg",
      "/gallery/Piatti/Piatti3.jpg",
      "/gallery/Piatti/Piatti4.jpg",
      "/gallery/Piatti/Piatti5.jpg",
      "/gallery/Piatti/Piatti6.jpg",
      "/gallery/Piatti/Piatti7.jpg",
      "/gallery/Piatti/Piatti8.jpg",
      "/gallery/Piatti/Piatti9.jpg",
      "/gallery/Piatti/Piatti10.jpg",
      // Add more
    ],
    Drinks: [
      "/gallery/Drinks/Drinks1.jpg",
      "/gallery/Drinks/Drinks2.jpg",
      "/gallery/Drinks/Drinks3.jpg",
      "/gallery/Drinks/Drinks4.jpg",
      "/gallery/Drinks/Drinks5.jpg",
      "/gallery/Drinks/Drinks6.jpg",
      "/gallery/Drinks/Drinks7.jpg",
      "/gallery/Drinks/Drinks8.jpg",
      "/gallery/Drinks/Drinks9.jpg",
      // Add more
    ],
    Localle: {
        Bar: [
            "/gallery/Localle/Bar/Bar1.jpg",
            "/gallery/Localle/Bar/Bar2.jpg",
            "/gallery/Localle/Bar/Bar3.jpg",
            "/gallery/Localle/Bar/Bar4.jpg",
            "/gallery/Localle/Bar/Bar5.jpg",
            "/gallery/Localle/Bar/Bar6.jpg",
            "/gallery/Localle/Bar/Bar7.jpg",
        ],
        Biblioteca: [
            "/gallery/Localle/Biblioteca/Biblioteca1.jpg",
            "/gallery/Localle/Biblioteca/Biblioteca2.jpg",
            "/gallery/Localle/Biblioteca/Biblioteca3.jpg",
            "/gallery/Localle/Biblioteca/Biblioteca4.jpg",
            "/gallery/Localle/Biblioteca/Biblioteca5.jpg",
            "/gallery/Localle/Biblioteca/Biblioteca6.jpg",
            "/gallery/Localle/Biblioteca/Biblioteca7.jpg",
        ],
        Cantinetta: [
            "/gallery/Localle/Cantinetta/Cantinetta1.jpg",
            "/gallery/Localle/Cantinetta/Cantinetta2.jpg",
            "/gallery/Localle/Cantinetta/Cantinetta3.jpg",
            "/gallery/Localle/Cantinetta/Cantinetta4.jpg",
            "/gallery/Localle/Cantinetta/Cantinetta5.jpg",
            "/gallery/Localle/Cantinetta/Cantinetta6.jpg",
        ],
        Dispensa: [
            "/gallery/Localle/Dispensa/Dispensa1.jpg",
            "/gallery/Localle/Dispensa/Dispensa2.jpg",
            "/gallery/Localle/Dispensa/Dispensa3.jpg",
            "/gallery/Localle/Dispensa/Dispensa4.jpg",
            "/gallery/Localle/Dispensa/Dispensa5.jpg",
            "/gallery/Localle/Dispensa/Dispensa6.jpg",
            "/gallery/Localle/Dispensa/Dispensa7.jpg",
        ],
        SallaDellaMusica: [
            "/gallery/Localle/SallaDellaMusica/SDM1.jpg",
            "/gallery/Localle/SallaDellaMusica/SDM2.jpg",
            "/gallery/Localle/SallaDellaMusica/SDM3.jpg",
            "/gallery/Localle/SallaDellaMusica/SDM4.jpg",
            "/gallery/Localle/SallaDellaMusica/SDM5.jpg",
            "/gallery/Localle/SallaDellaMusica/SDM6.jpg",
            "/gallery/Localle/SallaDellaMusica/SDM7.jpg",
        ],
        Studio: [
            "/gallery/Localle/Studio/Studio1.jpg",
            "/gallery/Localle/Studio/Studio2.jpg",
            "/gallery/Localle/Studio/Studio3.jpg",
            "/gallery/Localle/Studio/Studio4.jpg",
            "/gallery/Localle/Studio/Studio5.jpg",
        ],
      // Add more subcategories
    },
  };

  const handleCategoryClick = (category, e) => {
    e.preventDefault();
    setSelectedCategory(category);
    if (category === "Localle") {
      setSelectedSubcategory("Bar"); // Default subcategory
    } else {
      setSelectedSubcategory(null);
    }
  };

  const handleSubcategoryClick = (subcategory, e) => {
    e.preventDefault();
    setSelectedSubcategory(subcategory);
  };

  const getImagePaths = () => {
    if (selectedCategory === "Localle") {
      return imageData.Localle[selectedSubcategory] || [];
    }
    return imageData[selectedCategory] || [];
  };

  const imagePaths = getImagePaths();

  return (
    <>
    <div className="page-content">
      <div className="menu-list">
        <ul className="categories-list">
          {["Piatti", "Drinks", "Localle"].map((category) => (
            <li key={category} className="category">
              <a
                href="#"
                className={selectedCategory === category ? "category-link-selected" : "category-link"}
                onClick={(e) => handleCategoryClick(category, e)}
              >
                {category}
              </a>
            </li>
          ))}
        </ul>
      </div>

      {selectedCategory === "Localle" && (
        <div className="menu-list">
            <div className="categories-list">
                {LOCALLE_SUBCATEGORIES.map((subcategory) => (
                <li key={subcategory} className="category">
                    <a
                        href="#"
                        className={selectedSubcategory === subcategory ? "category-link-selected" : "category-link"}
                        onClick={(e) => handleSubcategoryClick(subcategory, e)}
                    >
                        {subcategory === "SallaDellaMusica" ? "Salla Della Musica" : subcategory}
                    </a>
                </li>
                ))}
                </div>
        </div>     
      )}

    </div>
    
    <StaticImageList images={imagePaths}></StaticImageList>
    </>
    
  );
};

export default GalleryComponent;
